module.exports = __webpack_public_path__ + "img/hr-tree-06-d-trunk.56bded59.png";